/** Mensaje de error del backend (ya localizado en `error`/`message`) o el texto de respaldo. */
export function apiErrorMessage(err: unknown, fallback?: string): string | undefined {
  const data = (err as { response?: { data?: { error?: unknown; message?: unknown } } } | null)?.response?.data;
  for (const v of [data?.error, data?.message]) {
    if (typeof v === 'string' && v.trim()) return v;
  }
  return fallback;
}
